import { ObjetKForm, requiredRule, combineRules, enumValue } from '@siclop/kstone-vue'
import { LeaveCategory } from '../enums'

export class LeaveTypeForm extends ObjetKForm {
  code: string = ''
  label: string = ''
  order: number = 0
  category: LeaveCategory = LeaveCategory.PaidLeave
  color: string = ''
  requiresDocument: boolean = false
  maxConsecutiveDays?: number
  isPaid: boolean = true
  deductsFromBalance: boolean = true
  /** Droit annuel en jours (null : sans droit annuel, ex. absence non décomptée). */
  annualEntitlement: number | null = null
  /** Acquisition mois par mois (congés payés) plutôt qu'en une fois en début de période. */
  accruesMonthly: boolean = false

  static validationRules = {
    code: combineRules(requiredRule('Le code est obligatoire')),
    label: combineRules(requiredRule('Le libellé est obligatoire'))
  }

  constructor(data?: Partial<LeaveTypeForm>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.label = data.label ?? ''
      this.order = data.order ?? 0
      this.category = enumValue(LeaveCategory, data.category, LeaveCategory.PaidLeave)
      this.color = data.color ?? ''
      this.requiresDocument = data.requiresDocument ?? false
      this.maxConsecutiveDays = data.maxConsecutiveDays
      this.isPaid = data.isPaid ?? true
      this.deductsFromBalance = data.deductsFromBalance ?? true
      this.annualEntitlement = data.annualEntitlement ?? null
      this.accruesMonthly = data.accruesMonthly ?? false
    }
  }
}
